export function dateFormatter(date, showTime = false) {
  const timestamp = typeof date === "string" && /^\d+$/.test(date) ? Number(date) : date;
  const options = { day: "2-digit", month: "short", year: "numeric", };

  if (showTime) {
    options.hour = "2-digit";
    options.minute = "2-digit";
    options.second = "2-digit";
    options.hour12 = true;
  }

  return new Date(timestamp).toLocaleString("en-US", options);
}

export const diagnosticCategories = [
  { value: "radiology", label: "Radiology" },
  { value: "pathology", label: "Pathology" },
  { value: "cardiology", label: "Cardiology" },
  { value: "physiotherapist", label: "Physiotherapist" },
  { value: "dietitian", label: "Dietitian" },
  { value: "mental_health", label: "Mental Health" }
];

export const pad = (n) => (n < 10 ? "0" + n : n);
export const today = new Date();

export const activeBorderColor = "#0195F7";
export const filledBorderColor = "#0195F74D";
export const pendingBorderColor = "#9B9B9B4D";
